import React from 'react';
import { OverlayView } from 'react-google-maps';
import CloudIcon from './CloudIcon';

const CloudOverlay = ({ position, data, onClick, children }) => {
  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={(width, height) => ({
        x: -(width / 2),
        y: -(height / 2),
      })}
    >
      <div
        onClick={onClick}
        style={{
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1000,
        }}
      >
        <CloudIcon
          intensidade={data.intensidade_chuva}
          cor={data.cor_intensidade}
          chuva15min={data.chuva_display || data.chuva_15min}
          size={40}
        />
        {children}
      </div>
    </OverlayView>
  );
};

export default CloudOverlay;
